import { projectArtifactSchema } from '@mio/shared';

import { apiRequest } from '@/shared/api/client';

/** Submitted files never change, so one cached read serves feedback and the file list. */
export const submissionFilesQuery = (submissionId: string) => ({
  queryKey: ['workshop', 'submission-files', submissionId] as const,
  queryFn: ({ signal }: { signal?: AbortSignal }) =>
    apiRequest(`/workshop/submissions/${submissionId}/files`, projectArtifactSchema, {
      ...(signal ? { signal } : {}),
    }),
  staleTime: Infinity,
  retry: false,
});
